import { styled, TableCell, TableRow } from '@mui/material';

const PREFIX = 'UserRow';

export const userRowClasses = {
  inactiveUser: `${PREFIX}-inactiveUser`,
  tableCell: `${PREFIX}-tableCell`,
  closeButton: `${PREFIX}-closeButton`,
};

export const StyledUserTableRow = styled(TableRow)(({ theme }) => ({
  [`& .${userRowClasses.inactiveUser}`]: {
    color: theme.palette.grey[400],
  },

  [`& .${userRowClasses.tableCell}`]: {
    cursor: 'pointer',
  },

  [`& .${userRowClasses.closeButton}`]: {
    position: 'absolute',
    top: '0.25rem',
    right: '0.25rem',
    padding: '0.125rem',
  },
}));

export const StyledUserTableCell = styled(TableCell)(() => ({
  fontSize: '16px',
}));
